export type IcStepperAlignment = "left" | "full-width";
